import { Component, Input, OnInit } from '@angular/core';
import { SmsHistorySortInput, SortEnumType, Uuid } from '../../../../../graphql';
import { Page } from '../../../../core/components/table-footer-paging/table-footer-paging.component';
import { BxUnverifiedAlertService } from '../../../../core/services/bx-unverified-alert.service';
import { FeatureService, PermissionService } from '../../../../core/services/permission';
import { SmsHistoryItem, SmsService } from '../../../../core/services/sms.service';
import { UserService } from '../../../../core/services/user';
import { Customer } from '../../../../data/models';
import { SortEvent } from '../../../../data/models/datatable.model';
import { SharedDataService } from '../../../../data/services/shared-data.service';
import { BreezeCase } from '../../../../utils/types/convert-case';
import { ClientsService } from '../../clients.service';

@Component({
    selector: 'app-clients-sms-list',
    templateUrl: './clients-sms-list.component.html',
    standalone: false,
})
export class ClientsSmsListComponent implements OnInit {
    @Input() customer!: BreezeCase<Customer>;
    rows: SmsHistoryItem[] = [];
    isLoading = false;
    page = new Page();
    sortBy: SmsHistorySortInput = { dateSent: SortEnumType.Asc };
    showCreate = false;

    constructor(
        private permissionService: PermissionService,
        private clientsService: ClientsService,
        private sharedData: SharedDataService,
        private bxUnverifiedAlertService: BxUnverifiedAlertService,
        private smsService: SmsService,
        private readonly userService: UserService,
        private readonly featureService: FeatureService
    ) {}

    ngOnInit(): void {
        this.showCreate =
            this.permissionService.isAvailable('customers.maintain-customers.send-customer-sms') &&
            this.featureService.isAvailable('sms-features') &&
            this.userService.isSmsEnabled;
        this.setDefaults();
        this.loadData();
    }

    async newSMS() {
        if (!this.sharedData.UserData.identityInfo.email_verified) {
            this.bxUnverifiedAlertService.trigger(this.sharedData.UserData.user);
            return;
        }
        await this.clientsService.smsCustomer(this.customer.ID_Customer);
        this.loadData();
    }

    setPage(pageNumber: number) {
        this.page.pageNumber = pageNumber;
        this.loadData();
    }

    pageLimit(event: { target: Node }) {
        this.page.size = Number.parseInt(event.target.textContent!);
        this.page.pageNumber = 0;
        this.loadData();
    }

    setDefaults() {
        this.page.pageNumber = 0;
        this.page.size = 10;

        this.sortBy = { dateSent: SortEnumType.Asc };
    }

    loadData() {
        this.isLoading = true;

        this.smsService
            .getSmsHistories({
                skip: this.page.pageNumber * this.page.size,
                take: this.page.size,
                order: [this.sortBy],
                where: { iD_Reference: { eq: this.customer.ID_Customer as Uuid } },
            })
            .subscribe((result) => {
                this.page.totalElements = result.data.smsHistories?.totalCount ?? 0;
                this.rows = result.data.smsHistories?.items ?? [];
                this.isLoading = false;
            });
    }

    onSort(event: SortEvent<SmsHistoryItem>) {
        this.sortBy = { [event.sorts[0].prop]: event.sorts[0].dir === 'desc' ? SortEnumType.Desc : SortEnumType.Asc };
        this.loadData();
    }
}
